import { ChangeForgotPWreq, ForgotPWreq, OptionTypes } from 'components/types/types';
import {
    BaseResponse,
    CompanyRegisterRequest,
    GetStartedCompanyResponse,
    GetStartedResponse,
    GetUserResponse,
    LoginRequest,
    LoginResponse,
    StartupRegisterRequest
} from '../../components/types';
import { getCall, patchCall, postCall } from './baseCall';
import { ChangePasswordReq } from 'components/types/Api';
import { ResetEmailReq } from 'components/types/Api'; 

const authEndpoint = 'api/Auth'
const matchEndpoint = 'api/Match'

export const getStartedStartup =
    async () => await getCall<GetStartedResponse>(`${authEndpoint}/GetStartedStartup`);

export const postRegisterStartup =
    async (request: StartupRegisterRequest) =>
        await postCall<StartupRegisterRequest, BaseResponse>(`${authEndpoint}/RegisterStartup`, request);

export const getStartedCompany =
    async () => await getCall<GetStartedCompanyResponse>(`${authEndpoint}/GetStartedCompany`);

export const postRegisterCompany =
    async (request: CompanyRegisterRequest) =>
        await postCall<CompanyRegisterRequest, BaseResponse>(`${authEndpoint}/RegisterCompany`, request);

export const postLogin =
    async (request: LoginRequest) =>
        await postCall<LoginRequest, LoginResponse>(`${authEndpoint}/Login`, request);

export const getUser =
    async () => await getCall<GetUserResponse>(`${authEndpoint}/GetUser`);

export const postForgotPassword =
    async (request: ForgotPWreq) =>
        await postCall<ForgotPWreq, BaseResponse>(`${authEndpoint}/ForgotPassword`, request);

export const postChangeForgotPassword =
    async (request: ChangeForgotPWreq) =>
        await postCall<ChangeForgotPWreq, LoginResponse>(`${authEndpoint}/ChangeForgotPassword`, request);

export const postChangePWE =
    async (request: ChangePasswordReq) =>
        await postCall<ChangePasswordReq, LoginResponse>(`${authEndpoint}/ChangeUserPassword`, request);

 export const postResetEmail =
    async (request: ResetEmailReq) =>
        await patchCall<ResetEmailReq, BaseResponse>(`${authEndpoint}/EmailCurrentReset`, request);  

export const getVerificationCode = 
       async () => getCall<BaseResponse>(`${authEndpoint}/GenerateCodeForEmailReset`);

    export const getMatchSlots =
   async () => await getCall<BaseResponse & { data:OptionTypes[]}>(`${matchEndpoint}/GetMatchSlots`);
  